$(document).ready(function () {
  // ------------------- TB_Services_CMS Start -------------------
  var tb_services_cms = $(
    "#tb-services-cms .tb-services-cms-wrapper"
  ).owlCarousel({
    items: 4, //1 items above 1000px browser width
    nav: false,
    dots: false,
    loop: false,
    center: false,
    autoplayHoverPause: true,
    autoplay: true,
    // rtl: rtlVal,
    responsive: {
      0: {
        items: 1,
      },
      551: {
        items: 2,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
  // ------------------- TB_Services_CMS End -------------------
  // ------------------- TB_Testimonial-CMS Start -------------------
  var tb_testimonial_cms = $("#TB-Testimonial-cms .owl-carousel").owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
        margin: 15,
      },
      768: {
        items: 2,
        margin: 15,
      },
      992: {
        items: 2,
        margin: 15,
      },
      1200: {
        items: 3,
        margin: 10,
      },
      1300: {
        items: 3,
        margin: 10,
      },
      1400: { items: 3 },
    },
  });
  // ------------------- TB_Testimonial-CMS End -------------------
  // ------------------- TB-Category Featured Start -------------------

  var TB_category_featured = $(
    "#TB-category-featured .tb-category-featured-carousel"
  ).owlCarousel({
    center: true,
    items: 3,
    loop: true,
    dots: true,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 2,
        margin: 15,
      },
      576: {
        items: 2,
        margin: 15,
      },
      768: {
        items: 3,
        margin: 15,
      },
      992: {
        items: 3,
      },
      1600: {
        items: 3,
      },
      1700: {
        items: 3,
      },
    },
  });

  // ------------------- TB-Category Featured End -------------------
});
